import { useQuery } from "@apollo/client"
import { TOURNAMENT_STANDING } from "../queries/tournamentStanding"

interface TournamentStandingInput {
  roundId: number
  drop?: boolean
}

type Standing = {
  id: number
  playerId: number
  position: number
  points: number
  omw: string
  pgw: string
  ogw: string
  TournamentPlayer: {
    raceId: number
    drop: number
    Person: {
      fullName: string
      code: string
      urlAvatar: string
    }
  }
}

export const useTournamentStanding = (input: TournamentStandingInput) => {
  const { data, loading, error, refetch } = useQuery(TOURNAMENT_STANDING, {
    variables: { TournamentStandingInput: input },
    errorPolicy: "all",
    skip: !input.roundId,
  })

  return {
    standing: data?.TournamentStanding?.Standing || [],
    status: data?.TournamentStanding?.status,
    loading,
    error,
    refetch,
  }
}
